import { Controller } from "@hotwired/stimulus"
import { getRecaptchaToken } from "../lib/recaptcha"

export default class extends Controller {
  static targets = ["formState", "successState", "emailInput", "successEmail", "errorMessage"]
  // templateGuid is for callers that only know which template the visitor picked once the
  // page is running — the docs builder, where it is a click, not a route. Pages that know it
  // at render time (public/templates/show) keep passing the hidden field instead.
  static values = { product: String, recaptchaSiteKey: String, templateGuid: String }

  open() {
    this.element.style.display = 'flex'
    this.formStateTarget.style.display = ''
    this.successStateTarget.style.display = 'none'
  }

  close() {
    this.element.style.display = 'none'
  }

  async submitEmail(event) {
    event.preventDefault()
    const email = this.emailInputTarget.value
    if (!email) return

    this._clearError()
    const form = event.target
    const formData = this._formData(form)

    const token = await this._getRecaptchaToken()
    if (token) {
      formData.append('g-recaptcha-response', token)
    }

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
          'Accept': 'application/json'
        }
      })

      if (response.ok) {
        this.successEmailTarget.textContent = `We've sent a link to ${email}`
        this.formStateTarget.style.display = 'none'
        this.successStateTarget.style.display = ''
        this.dispatch('success', { detail: { email, product: this.productValue } })
      } else {
        const data = await response.json()
        this._showError(data.error || 'Something went wrong')
      }
    } catch {
      this._showError('Network error. Please try again.')
    }
  }

  resend(event) {
    event.preventDefault()
    const form = this.element.querySelector('form')
    if (form) {
      const formData = this._formData(form)
      this._getRecaptchaToken().then(token => {
        if (token) {
          formData.append('g-recaptcha-response', token)
        }
        fetch(form.action, {
          method: 'POST',
          body: formData,
          headers: {
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
            'Accept': 'application/json'
          }
        })
      })
    }
  }

  _formData(form) {
    const formData = new FormData(form)
    if (this.templateGuidValue) formData.set('template_guid', this.templateGuidValue)

    return formData
  }

  _showError(message) {
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.textContent = message
      this.errorMessageTarget.style.display = ''
    }
  }

  _clearError() {
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.textContent = ''
      this.errorMessageTarget.style.display = 'none'
    }
  }

  _getRecaptchaToken() {
    return getRecaptchaToken(this.recaptchaSiteKeyValue, 'signup')
  }
}
